import { createFileRoute } from "@tanstack/react-router";
import { Camera } from "lucide-react";
import { useSiteSection } from "@/hooks/useSiteContent";
import { PageHero, PageIntro } from "@/components/site/PageHero";
import { SimplePlans } from "@/components/site/SimplePlans";
import { Reveal } from "@/components/site/Reveal";

export const Route = createFileRoute("/cameras")({
  head: () => ({
    meta: [
      { title: "Câmeras de Segurança — Monitoramento Contato Internet" },
      {
        name: "description",
        content:
          "Planos de câmeras de segurança com instalação, gravação em nuvem e acesso pelo celular a qualquer hora, com suporte local da Contato.",
      },
      { property: "og:title", content: "Câmeras de Segurança — Contato Internet" },
      {
        property: "og:description",
        content: "Monitoramento com gravação em nuvem e acesso pelo app.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: CamerasPage,
});

function CamerasPage() {
  const cameras = useSiteSection("cameras");

  return (
    <>
      <PageHero eyebrow={cameras.eyebrow} title={cameras.title} subtitle={cameras.subtitle} />
      <PageIntro text={cameras.text} />

      <section className="bg-background pb-14 sm:pb-20">
        <div className="mx-auto max-w-7xl px-5">
          <Reveal variant="fade-up">
            <SimplePlans
              items={cameras.items}
              icon={Camera}
              waPrefix="Olá! Quero contratar o plano de câmeras"
            />
          </Reveal>
        </div>
      </section>
    </>
  );
}
